import { render } from "./HealthBar.vue?vue&type=template&id=78346616"
import script from "./HealthBar.vue?vue&type=script&lang=js"
export * from "./HealthBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__